import { Component, OnInit, SecurityContext } from '@angular/core';
import { Observable } from 'rxjs';
import { RouterService } from '@shared/services/router.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: false,
})
export class HeaderComponent implements OnInit {
  routeData$: Observable<any>;
  title$: Observable<string>;
  subtitle: SafeHtml | null = null;

  constructor(
    private routerService: RouterService,
    private sanitizer: DomSanitizer,
  ) {}

  ngOnInit(): void {
    this.routeData$ = this.routerService.getRouteData();
    this.routeData$.subscribe((data) => {
      if (!!data) {
        this.subtitle = data.subtitle ? this.sanitizer.sanitize(SecurityContext.HTML, data.subtitle) : null;
      }
    });
  }
}
